export interface MidSocketResponse {
  control_code?: string;
  finished?: boolean;
  result?: MIDSessionResultCode;
  error?: MIDSessionErrorCode;
  message?: string;
}

export enum MIDSessionResultCode {
  OK = 'OK', // session was completed successfully, there is a certificate, document number and possibly signature in return structure.
  USER_ERROR = 'USER_ERROR',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  USER_CANCELLED = 'USER_CANCELLED',
}

export enum MIDSessionErrorCode {
  MISSING_PROPERTIES = 'missing_properties',
  INVALID_PROPERTIES = 'invalid_properties',
  NOT_MID_CLIENT = 'NOT_MID_CLIENT',
}
